<template>
  <section class="accordions module">
    <div class="container">
      <div class="accordions-container">
        <Accordion
          v-for="(item, index) in data.accordions"
          :key="index"
          :item="item" />
      </div>
    </div>
  </section>
</template>

<script setup>
/* #META
   {
    "NAME": "AccordionsComponent",
    "CLASSNAME": "accordions",
    "URL": "http://eikon.local/"
   }
  #ENDMETA */
import Accordion from '@/components/modules/Accordions/Accordion.vue'

defineProps(['data'])
</script>

<style lang="scss">
.accordions {
  color: $white;
  background-color: $black;

  .accordions-container {
    position: relative;
  }
}
</style>
